import React, { useEffect, useRef } from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'

import { Navigation, Pagination } from 'swiper/modules';


import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/grid';
import 'swiper/css/pagination'
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi';

import { sampleProducts } from '../lib/FakeData';
import ProductCard from './ProductCard';
import { useSelector } from 'react-redux';

export const SliderProducts = ({ isCountDown }) => {
    const productList = useSelector((state) => state.productList);
    const { loading, error, products } = productList;
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current && swiperRef.current.params.navigation !== false) {
            swiperRef.current.params.navigation.prevEl = prevRef.current;
            swiperRef.current.params.navigation.nextEl = nextRef.current;
            swiperRef.current.navigation.init();
            swiperRef.current.navigation.update();
        }
    }, []);
    return (
        <div className='w-full flex items-center justify-center relative'>
            <Swiper
                modules={[Navigation, Pagination]}
                slidesPerView={5}
                spaceBetween={0}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                pagination={{ clickable: true }} // bật mặc định
                navigation={false} // tắt mặc định
                breakpoints={{
                    0: {
                        // Từ tablet trở lên
                        slidesPerView: 2,
                        spaceBetween: 10,
                        pagination: false,
                        // navigation: {
                        //     prevEl: prevRef.current,
                        //     nextEl: nextRef.current,
                        // },
                    },
                    768: {
                        // Từ tablet trở lên
                        slidesPerView: 3,
                        spaceBetween: 10,
                        pagination: false,
                        // navigation: {
                        //     prevEl: prevRef.current,
                        //     nextEl: nextRef.current,
                        // },
                    },
                    1024: {
                        // Từ tablet trở lên
                        slidesPerView: 4,
                        spaceBetween: 20,
                        pagination: false,
                        // navigation: {
                        //     prevEl: prevRef.current,
                        //     nextEl: nextRef.current,
                        // },
                    },
                    1440: {
                        // Từ tablet trở lên
                        slidesPerView: 5,
                        spaceBetween: 0,
                        pagination: false,
                        // navigation: {
                        //     prevEl: prevRef.current,
                        //     nextEl: nextRef.current,
                        // },
                    },
                }}
            >
                {products && products?.map((item, index) => (
                    <SwiperSlide key={index}   >
                        <ProductCard product={item} isCountDown={isCountDown} />
                    </SwiperSlide>
                ))}

            </Swiper>
            {/* Custom buttons */}
            <button
                ref={prevRef}
                className="hidden md:flex  absolute left-2 top-1/2 -translate-y-1/2 z-10 p-2 
       bg-[--color-button-3] text-[--color-button-1] rounded-full
       opacity-0 -translate-x-5
       group-hover:opacity-100 group-hover:translate-x-0
       transition-all duration-300 ease-in-out
       hover:bg-[--color-button-2]"
            >
                <HiOutlineChevronLeft />
            </button>

            {/* Nút Next */}
            <button
                ref={nextRef}
                className="hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 z-10 p-2 
       bg-[--color-button-3] text-[--color-button-1] rounded-full
       opacity-0 translate-x-5
       group-hover:opacity-100 group-hover:translate-x-0
       transition-all duration-300 ease-in-out
       hover:bg-[--color-button-2]"
            >
                <HiOutlineChevronRight />
            </button>
        </div>
    )
}
